<style>
    .rdo-cif-transportadora:hover {
        background-color: #dff4fb;
        cursor: pointer
    }

    .rdo-cif-transportadora-selecionada {
        background-color: #f1fafd;
    }
</style>
<template>
    <main id="main" class="main-site">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="box-title">Transportadora</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <FormHelper :inputVar="cartInfo.tipoFrete"
                                :form="cartInfo"
                                :options="tipoFrete()"
                                id="rdoTipoFrete"
                                type="radio"
                                label="Selecione o tipo de frete">
                    </FormHelper>
                </div>
            </div>

            <div v-if="!loading">
                <div class="row" v-if="cartInfo.filialOrigemLocalidade">
                    <div class="col-md-12">
                        <div class="alert-group">
                            <div class="alert alert-info alert-dismissable">
                                <div style="font-size: 13px">
                                    <span>CD Origem: <strong>{{ cartInfo.filialOrigemLocalidade }}</strong> </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <p>
                            Local de Entrega: <strong>{{ cartInfo.address }}</strong>
                        </p>
                    </div>
                </div>

                <div v-if="cartInfo.tipoFrete.value == 'cif'">
                    <div v-if="erroCifTransportadora">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="alert alert-info" role="alert">
                                    <p><strong>Falha ao obter transportadoras CIF, por favor tente novamente.</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="cifIndisponivel && !erroCifTransportadora && !loadingCif">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="alert alert-info" role="alert">
                                    <p><strong>CIF indisponível para sua região.</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="row">
                            <div class="col-md-12">
                                <div style="padding: 7px; border: #40b9e6 solid 1px; border-radius: 4px; margin: 10px 0;" v-for="option in cifTransportadora">
                                    <label v-for="comDescarga in obterOpcoesDescarga(option)"
                                           class="rdo-cif-transportadora"
                                           v-bind:class="{ 'rdo-cif-transportadora-selecionada': verificarCifSelecionada(option, comDescarga) }"
                                           style="display: block; width: 100%; padding: 8px 5px; margin-bottom: 0; border-radius: 4px;">
                                        <div class="row">
                                            <div class="col-md-3" style="padding-top: 6px;">
                                                <div class="inline-radio" style="margin-top: 0 !important;">
                                                    <input type="radio"
                                                           name="rdoCifTransportadora"
                                                           style="margin-top: 0; margin-right: 6px;"
                                                           :checked="verificarCifSelecionada(option, comDescarga)"
                                                           @change="mudarCifTransportadora(option, comDescarga)" />
                                                    <span style="position: relative; top: -2px;">{{ option.RazaoSocial }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div style="background: #d9f1fa; border-radius: 4px; padding: 3px 0; font-weight: bold; color: #00a1de; text-align: center; margin-top: 3px" v-if="comDescarga">
                                                    + Descarga
                                                    <span v-if="obterValorDescarga(option) == 0"> grátis</span>
                                                </div>
                                            </div>
                                            <div class="col-md-1"></div>
                                            <div class="col-md-3" style="padding-top: 5px;">
                                                <span v-if="option.Prazo != null">
                                                    Prazo de entrega em {{ option.Prazo == 1 ? "1 dia" : option.Prazo + " dias" }}
                                                </span>
                                            </div>
                                            <div class="col-md-3" style="padding-top: 5px;">
                                                Valor logística: <span style="font-weight: bold;">{{ obterValorLogisticaFormatado(option, comDescarga) }}</span>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <div style="margin: 15px 0;" v-show="cartInfo.incluirDescarga">
                                    <b>Atenção:</b>
                                    Serviço de descarga manual. Poderá haver cobrança adicional para outras necessidades (Munck, empilhadeira, etc)
                                </div>
                                <div class="alert-group">
                                    <div class="alert alert-warning alert-dismissable">
                                        <strong>Aviso!</strong> <br />
                                        <div style="font-size: 13px">
                                            <span>O valor pode sofrer variações se o local de entrega for área rural.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!cifIndisponivel">
                        <hr />
                        <div class="row">
                            <div class="col-md-12">
                                <div class="alert alert-warning" role="alert">
                                    <p><strong>Informe o nome e telefone para agendar à entrega. Não utilize o campo observação para este fim.</strong></p>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="font-weight: bold" id="rowAgendamentoEntrega">
                            <div class="col-md-2">
                                <label style="font-weight: bold; padding-top: 30px; font-size: 18px">Agendar Entrega</label>
                            </div>
                            <div class="col-md-5">
                                <FormHelper :inputVar="cartInfo.entrega_nome"
                                            :form="cartInfo"
                                            :lostFocus="this.updateObsAgendamentoEntrega"
                                            maxlength="40"
                                            label="Nome"
                                            type="text"
                                            id="txtEntregaNome"
                                            class="agendamento_entrega"
                                            name="txtEntregaNome"
                                            placeholder="Nome">
                                </FormHelper>
                            </div>
                            <div class="col-md-5">
                                <FormHelper :inputVar="cartInfo.entrega_telefone"
                                            :form="cartInfo"
                                            :lostFocus="this.updateObsAgendamentoEntrega"
                                            maxlength="40"
                                            label="Telefone"
                                            type="text"
                                            class="agendamento_entrega"
                                            id="txtEntregaTelefone"
                                            name="txtEntregaTelefone"
                                            placeholder="Telefone">
                                </FormHelper>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="cartInfo.tipoFrete.value == 'fob'">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="alert alert-danger" role="alert">
                                <p>
                                    <strong>Atenção! Contratação, pagamento e risco do transporte é de responsabilidade do destinatário.</strong><br />
                                    Caso não encontre sua transportadora de preferência, na lista abaixo, entre em contato com a área comercial para providenciarmos o
                                    cadastro dela.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-md-12">
                            <strong>Para Frete FOB, verifique com a transportadora escolhida se há disponibilidade de atendimento em sua região</strong>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-md-12">
                            <FormHelper :inputVar="cartInfo.fob"
                                        :form="cartInfo"
                                        :options="fobCompanies"
                                        type="select"
                                        label="Transportadora para frete FOB"
                                        placeholder="Transportadora"
                                        :change="this.mudarFobTransportadora">
                            </FormHelper>
                        </div>
                    </div>
                    <div v-if="responsibleVisible">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="alert alert-info" role="alert">
                                    <p><strong>Informe o responsável pela retira, abaixo.</strong></p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-10">
                                <FormHelper :inputVar="cartInfo.responsible"
                                            :form="cartInfo"
                                            :options="responsibles"
                                            type="select"
                                            label="Responsável para retira"
                                            placeholder="Responsável">
                                </FormHelper>
                            </div>
                            <div class="col-md-2 col-only-button" style="z-index: -1">
                                <input id="resp-code" class="form-control" value="" disabled="true" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <FormHelper :inputVar="cartInfo.obs"
                                    :form="cartInfo"
                                    :lostFocus="this.updateObsCliente"
                                    maxlength="200"
                                    label="Observação"
                                    type="textarea"
                                    id="txtArea"
                                    name="txtArea"
                                    placeholder="Observação">
                        </FormHelper>
                    </div>
                </div>
            </div>

            <Loader v-if="loading" />
        </div>
    </main>
</template>

<script>
    import FormHelper from './partials/FormHelper.vue'
    import swal from 'sweetalert'
    import $ from 'jquery'
    import TransportadoraService from './../services/TransportadoraService'
    import CarrinhoService from './../services/CarrinhoService'

    export default {
        name: 'SelectShippingNew',
        components: {
            FormHelper,
        },
        props: {
            valorTotal: { type: Number, default: 0 },
            formulario: { type: Object }
        },
        mounted() {
            this.loading = true
            this.session = JSON.parse(localStorage.getItem('usuarioLogado'))
        },
        data() {
            return {
                loading: true,
                codigoTransportadora: 0,
                rgResponsavel: '',
                showCifCompanies: true,
                codigoKombiInt: 0,
                blockRetira: false,
                session: {},
                fobCompanies: [],
                responsibles: [],
                cifTransportadora: [],
                cartInfo: {
                    attemptSubmit: false,
                    tipoFrete: new this.$formInput(true, localStorage.tipoFrete),
                    tipo: this.$route.params.tipo,
                    kombiCode: '',
                    totalAmount: 0,
                    entrega_nome: new this.$formInput(true),
                    entrega_telefone: new this.$formInput(true),
                    obs: new this.$formInput(false, ''),
                    cif: new this.$formInput(false, localStorage.GetTipoPedido === 'VENDA NORMAL' ? localStorage.cifKombi : localStorage.cifKombiDirect),
                    fob: new this.$formInput(false, localStorage.GetTipoPedido === 'VENDA NORMAL' ? localStorage.fobKombi : localStorage.fobKombiDirect),
                    incluirDescarga: localStorage.incluirDescarga == "true",
                    responsible: new this.$formInput(false),
                    address: '',
                    filialOrigemLocalidade: '',
                },
                cifCompanies: [],
                callUpdateCompanieCif: false,
                callUpdateCompanieFob: false,
                erroCifTransportadora: false,
                loadingCif: false
            }
        },
        watch: {
            'cartInfo.tipoFrete.value': function (v) {
                localStorage.tipoFrete = v
                this.loading = true

                if (v === 'cif') {
                    this.callUpdateCompanieCif = true
                    this.getCifCompanies()
                } else {
                    this.callUpdateCompanieFob = true
                    this.getFobCompanies()
                }
            },

            'cartInfo.responsible.value': function (v) {
                const $code = $('#resp-code')

                if (v != null) {
                    $code.val(v.code)
                    this.updateResponsible(v)
                } else {
                    $code.val('')
                }
            },

            valorTotal: function () {
                this.loading = true
                if (localStorage.tipoFrete === 'cif') {
                    this.getCifCompanies()
                } else {
                    this.getFobCompanies()
                }
            },

            formulario: function () {
                this.dadosFormulario()
            },
        },
        methods: {
            updateObsCliente: function () {
                const observacao = this.cartInfo.obs.value

                let xhr = new XMLHttpRequest()
                xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AlterarObsCliente')
                xhr.setRequestHeader('Content-type', 'application/json')
                xhr.withCredentials = true
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        let retorno = JSON.parse(xhr.responseText)
                        if (retorno[0].includes('Aviso')) {
                            swal({
                                title: 'Aviso',
                                text: retorno[1],
                                icon: 'warning',
                            })
                        } else if (retorno[0].includes('OK')) {
                            swal({
                                title: 'Observação atualizada com sucesso!',
                                icon: 'success',
                            })
                        }
                    }
                }
                xhr.send(
                    JSON.stringify({
                        codigoPedido: this.formulario.Codigo_pedido,
                        observacao: observacao,
                    })
                )
            },
            updateObsAgendamentoEntrega: function () {
                const valueTelefone = this.cartInfo.entrega_telefone.value.trim()
                const valueNome = this.cartInfo.entrega_nome.value.trim()

                if (valueTelefone == '' || valueNome == '') return

                let xhr = new XMLHttpRequest()
                xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AlterarObsClienteAgendamentoEntrega')
                xhr.setRequestHeader('Content-type', 'application/json')
                xhr.withCredentials = true
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        let retorno = JSON.parse(xhr.responseText)
                        this.saveAgendamentoLocal(this.formulario.Codigo_pedido, valueNome, valueTelefone)

                        if (retorno[0].includes('Aviso')) {
                            swal({
                                title: 'Aviso',
                                text: retorno[1],
                                icon: 'warning',
                            })
                        } else if (retorno[0].includes('OK')) {
                            swal({
                                title: 'Contato atualizado com sucesso!',
                                icon: 'success',
                            })
                        }
                    }
                }
                xhr.send(
                    JSON.stringify({
                        codigoPedido: this.formulario.Codigo_pedido,
                        nome: valueNome,
                        telefone: valueTelefone,
                    })
                )
            },
            tipoFrete: function () {
                return [
                    { code: 0, label: 'Frete CIF - por conta do emitente', value: 'cif' },
                    { code: 1, label: 'Frete FOB - por conta do destinatário', value: 'fob' },
                ]
            },
            getCifTransportadoraSelecionada: function () {
                if (this.cartInfo.tipoFrete.value != 'cif')
                    return null;

                const codigo = this.cartInfo.cif.value;
                const codigoStorage = parseInt(localStorage.codigoCif);
                const nome = localStorage.GetTipoPedido === 'VENDA NORMAL' ? localStorage.cifKombi : localStorage.cifKombiDirect;
                let transportadora;

                if (codigo || codigoStorage || nome) {
                    transportadora =
                        this.cifTransportadora.find(c => c.code == codigo || c.code == codigoStorage) ||
                        this.cifTransportadora.find(c => c.RazaoSocial === nome);
                }

                return transportadora;
            },
            verificarCifSelecionada: function (transportadora, incluirDescarga) {
                return this.getCifTransportadoraSelecionada() == transportadora && this.cartInfo.incluirDescarga == incluirDescarga;
            },
            obterOpcoesDescarga: function (transportadora) {
                const opcoes = [];

                if (transportadora.ValorTaxaDescarga == null || this.obterValorDescarga(transportadora) > 0)
                    opcoes.push(false);

                if (this.possuiServicoDescarga(transportadora))
                    opcoes.push(true);

                return opcoes;
            },
            possuiServicoDescarga: function (transportadora) {
                return transportadora.ValorTaxaDescarga != null;
            },
            obterValorDescarga: function (transportadora) {
                return transportadora.ValorTaxaDescarga + transportadora.ValorMarkupDescarga;
            },
            obterValorLogisticaFormatado: function (transportadora, incluirDescarga) {
                let valor = transportadora.valorFrete;

                if (incluirDescarga)
                    valor += this.obterValorDescarga(transportadora);

                return valor == 0 ? "Grátis" : this.formatCurrency(valor);
            },
            dadosFormulario: function () {
                this.loading = true

                const keys = Object.keys(this.formulario)
                if (keys.length > 0) {
                    let json = this.formulario

                    if (json.Codigo_transportadora == 0) {
                        this.cartInfo.cif.value = null
                        this.cartInfo.fob.value = null
                    }
                    else if (json.Codigo_transportadora == 29) this.rgResponsavel = json.Rg_responsavel_retira
                    else this.codigoTransportadora = json.Codigo_transportadora

                    this.blockRetira = json.PedidoGeradorOuPainel
                    this.cartInfo.obs.value = json.Observacao_cliente
                    this.cartInfo.kombiCode = json.Codigo_pedido + '-' + json.Dv_pedido
                    this.cartInfo.address = json.Endereco_cliente + ', ' + json.Cidade_cliente + ' - ' + json.Uf_cliente + ', CEP: ' + json.Cep_cliente

                    this.getResponsible()
                    this.getAgendamentoLocal(this.formulario.Codigo_pedido)
                }

                this.loading = false
            },
            formatCurrency: function (v) {
                v = v ? v.toString().replace(',', '.') : 0
                const formato = {
                    minimumFractionDigits: 2,
                    style: 'currency',
                    currency: 'BRL',
                }
                return parseFloat(v).toLocaleString('pt-BR', formato)
            },
            updateCompanieCif: function (data, update = true) {
                if (update) this.$emit('showLoading', true)
                CarrinhoService.AlterarTransportadora(this.$apiUrl, data)
                    .then(() => {
                        if (update) this.$emit('updateCarrinho')
                    })
                    .catch((error) => {
                        console.log(error)
                        this.$emit('showLoading', false)
                    })
            },
            getCifCompanies: function () {
                if (this.formulario.Codigo_pedido > 0) {
                    this.loadingCif = true;

                    this.cartInfo.filialOrigemLocalidade = null
                    this.cifTransportadora = []

                    TransportadoraService.Loadcif(this.$apiUrl, this.formulario.Codigo_pedido).then((json) => {

                        if (json.length > 0)
                            this.cartInfo.filialOrigemLocalidade = json[0].DadosFrete.FilialOrigemLocalidade;

                        json.forEach((element) => {
                            let item = {}
                            item.code = element.DadosTransportadora.Codigo
                            item.RazaoSocial = element.DadosTransportadora.RazaoSocial
                            item.Prazo = element.DadosTransportadora.PrazoEntrega
                            item.Frete = element.DadosFrete.frete
                            item.value = element.DadosTransportadora.Codigo
                            item.valorFrete = element.DadosFrete.valorFreteCalculado
                            item.tipoAereo = !!element.DadosTransportadora.Aereo && element.DadosTransportadora.Aereo != 'T'
                            item.ValorTaxaDescarga = element.DadosTransportadora.ValorTaxaDescarga
                            item.ValorMarkupDescarga = element.DadosTransportadora.ValorMarkupDescarga
                            this.cifTransportadora.push(item)
                        })

                        const cifSelecionada = this.getCifTransportadoraSelecionada() || this.cifTransportadora[0];

                        if (cifSelecionada) {
                            this.cartInfo.cif.value = cifSelecionada.code

                            var opcoesDescarga = this.obterOpcoesDescarga(cifSelecionada)

                            if (!opcoesDescarga.some(o => o == this.cartInfo.incluirDescarga))
                                this.cartInfo.incluirDescarga = opcoesDescarga[0];

                            const dataTransp = {
                                codigoPedido: this.formulario.Codigo_pedido,
                                codigoTransportadora: cifSelecionada.code,
                                tipoFrete: 0,
                                tipoCorreio: this.formulario.Tipo_correio,
                                valorFrete: cifSelecionada.valorFrete.toString().replace('.', ','),
                                valorTaxaDescarga: this.cartInfo.incluirDescarga ? cifSelecionada.ValorTaxaDescarga : null,
                                valorMarkupDescarga: this.cartInfo.incluirDescarga ? cifSelecionada.ValorMarkupDescarga : null,
                                tipoAereo: cifSelecionada.tipoAereo,
                            }
                            this.updateCompanieCif(dataTransp, this.callUpdateCompanieCif)
                            this.callUpdateCompanieCif = false
                        }

                        this.loading = false;
                        this.loadingCif = false;
                    }).catch((e) => {
                        const message = `Falha ao obter transportadoras CIF ${localStorage.GetTipoPedido}: ${e.message}`;
                        this.erroCifTransportadora = true;
                        this.loading = false
                        this.loadingCif = false;
                        TransportadoraService.GravarErroCalculoFrete(this.$apiUrl, message, this.formulario.Codigo_pedido, this.formulario.Cep_cliente);
                    })
                }
            },
            updateCompanieFob: function (item, update = true) {
                if (update) this.$emit('showLoading', true)
                const xhr = new XMLHttpRequest()
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        if (xhr.responseText != '' && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText)
                            if (update) this.$emit('updateCarrinho')
                        }
                    }
                }
                xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AlterarTransportadora')
                xhr.setRequestHeader('Content-Type', 'application/json')
                xhr.withCredentials = true

                xhr.send(
                    JSON.stringify({
                        codigoPedido: this.formulario.Codigo_pedido,
                        codigoTransportadora: item ? item.code : 0,
                        tipoFrete: 1,
                        tipoCorreio: -1,
                        valorFrete: 0,
                        tipoAereo: false,
                    })
                )
            },
            getFobCompanies: function () {
                this.cifCompanies = []
                this.cartInfo.filialOrigemLocalidade = null

                if (localStorage.meioPagamento === 'Boleto' && !this.blockRetira) {
                    this.showCifCompanies = false

                    let obj = { code: 29, label: 'O MESMO' }
                    this.fobCompanies.push(obj)
                    this.cartInfo.fob.value = obj

                    this.updateCompanieFob(null, this.callUpdateCompanieFob)
                    this.callUpdateCompanieFob = false
                    return
                }

                const xhr = new XMLHttpRequest()
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        if (xhr.responseText != '' && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText)

                            this.fobCompanies = []

                            if (this.blockRetira == false) {
                                this.fobCompanies.push({ code: 29, label: 'O MESMO' })
                            }
                            json.forEach((element) => {
                                let item = {}
                                item.code = element.TraCodigo
                                item.label = element.SaidaParaTela
                                this.fobCompanies.push(item)
                            })

                            let fobSelecionada = this.fobCompanies.filter((c) => c.code == this.codigoTransportadora)
                            if (fobSelecionada.length > 0) this.cartInfo.fob.value = fobSelecionada[0]
                        }
                        this.updateCompanieFob(null, this.callUpdateCompanieFob)
                        this.callUpdateCompanieFob = false
                    }
                    this.loading = false
                }
                xhr.open('POST', this.$apiUrl + 'Transportadora.svc/loadfob')
                xhr.setRequestHeader('Content-Type', 'application/json')
                xhr.withCredentials = true
                xhr.send(
                    JSON.stringify({
                        emp_filial: 1,
                        uf: this.formulario.Uf_cliente,
                        cidade: this.formulario.Cidade_cliente,
                    })
                )
            },
            getResponsible: function () {
                this.responsibles = []
                const xhr = new XMLHttpRequest()
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        if (xhr.responseText != '' && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText)

                            json.forEach((element) => {
                                let item = {
                                    code: element.RgRespRetira,
                                    label: element.NomeRespRetira,
                                }
                                this.responsibles.push(item)
                            })

                            let responsavel = this.responsibles.filter((c) => c.code == this.rgResponsavel)
                            if (responsavel.length > 0) {
                                this.cartInfo.responsible.value = responsavel[0]
                            }
                        }
                    }
                }
                xhr.open('POST', this.$apiUrl + 'Transportadora.svc/loadclientesretira')
                xhr.setRequestHeader('Content-Type', 'application/json')
                xhr.withCredentials = true
                xhr.send()
            },
            updateResponsible: function (item) {
                const xhr = new XMLHttpRequest()

                xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AlterarResponsavelRetira')
                xhr.setRequestHeader('Content-type', 'application/json')
                xhr.withCredentials = true

                xhr.onload = () => {
                    if (xhr.status == 200) {
                        // console.log('alterarResponsavel', JSON.parse(xhr.responseText))
                    }
                }

                xhr.send(
                    JSON.stringify({
                        codigoPedido: this.formulario.Codigo_pedido,
                        nomeResponsavel: item.label,
                        rgResponsavel: item.code,
                    })
                )
            },
            mudarCifTransportadora: function (item, incluirDescarga) {
                if (item != null) {
                    this.cartInfo.fob.value = null
                    this.cartInfo.cif.value = item.code
                    this.cartInfo.incluirDescarga = incluirDescarga

                    localStorage.codigoCif = item.code
                    localStorage.incluirDescarga = incluirDescarga

                    if (localStorage.GetTipoPedido === 'VENDA NORMAL') {
                        localStorage.cifKombi = item.RazaoSocial
                        localStorage.fobKombi = 'Transportadora'
                    } else {
                        localStorage.cifKombiDirect = item.RazaoSocial
                        localStorage.fobKombiDirect = 'Transportadora'
                    }

                    this.$emit('showLoading', true)

                    const dataTransp = {
                        codigoPedido: this.formulario.Codigo_pedido,
                        codigoTransportadora: item ? item.code : 0,
                        tipoFrete: 0,
                        tipoCorreio: this.formulario.Tipo_correio,
                        valorFrete: item.valorFrete.toString().replace('.', ','),
                        valorTaxaDescarga: incluirDescarga ? item.ValorTaxaDescarga : null,
                        valorMarkupDescarga: incluirDescarga ? item.ValorMarkupDescarga : null,
                        tipoAereo: item.tipoAereo,
                    }

                    this.updateCompanieCif(dataTransp)
                }
            },
            mudarFobTransportadora: function (item) {
                if (item != null) {
                    this.cartInfo.cif.value = null
                    this.cartInfo.incluirDescarga = false

                    localStorage.incluirDescarga = null;

                    if (localStorage.GetTipoPedido === 'VENDA NORMAL') {
                        localStorage.fobKombi = item.label
                        localStorage.cifKombi = null
                    } else {
                        localStorage.fobKombiDirect = item.label
                        localStorage.cifKombiDirect = null
                    }

                    this.$emit('showLoading', true)

                    this.updateCompanieFob(item)
                } else {
                    this.cartInfo.responsible.value = null
                }
            },
            getAgendamentoLocal: function (codigoPedido) {
                let agendamentoLocal = localStorage.getItem('agendamentoPedido-' + codigoPedido) || { nome: '', telefone: '' }

                if (typeof agendamentoLocal !== 'object') {
                    agendamentoLocal = JSON.parse(agendamentoLocal)
                }

                this.cartInfo.entrega_nome.value = agendamentoLocal.nome
                this.cartInfo.entrega_telefone.value = agendamentoLocal.telefone
            },
            saveAgendamentoLocal: function (codigoPedido, nome, telefone) {
                localStorage.setItem('agendamentoPedido-' + codigoPedido, JSON.stringify({ nome: nome, telefone: telefone }))
            },
        },
        computed: {
            responsibleVisible: function () {
                return this.cartInfo.fob.value != null && this.cartInfo.fob.value.code == 29
            },

            cifIndisponivel: function () {
                return this.cifTransportadora.length < 1 || (this.formulario.Cidade_cliente === 'MARINGA' && this.blockRetira === false)
            },
        },
    }
</script>
